import { InputGroup, InputGroupAddon, InputGroupInput } from '@savvy-kit/components/input-group';
import { Search } from 'lucide-react';

type Props = {
  readonly value: string;
  readonly onSearch: (value: string) => void;
};

export function TaxSearchField({ value, onSearch }: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
  };

  return (
    <InputGroup className="w-[384px]">
      <InputGroupAddon align="inline-start">
        <Search className="size-4 text-secondary" />
      </InputGroupAddon>
      <InputGroupInput value={value} onChange={handleChange} placeholder="Search client name" />
    </InputGroup>
  );
}
